import type { SVGProps } from 'react';

type PrepareMeetingIconProps = Omit<SVGProps<SVGSVGElement>, 'ref'> & {
    className?: string;
    strokeWidth?: number;
};

export const CrosshairIcon = ({
    className,
    strokeWidth = 1.8,
    ...props
}: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <circle
            cx={12}
            cy={12}
            r={10}
        />
        <line
            x1={22}
            x2={18}
            y1={12}
            y2={12}
        />
        <line
            x1={6}
            x2={2}
            y1={12}
            y2={12}
        />
        <line
            x1={12}
            x2={12}
            y1={6}
            y2={2}
        />
        <line
            x1={12}
            x2={12}
            y1={22}
            y2={18}
        />
    </svg>
);

export const CircleCheckBigIcon = ({
    className,
    strokeWidth = 2,
    ...props
}: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path d={'M21.801 10A10 10 0 1 1 17 3.335'} />
        <path d={'m9 11 3 3L22 4'} />
    </svg>
);

export const CheckIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path d={'m5 12 4 4L19 6'} />
    </svg>
);

export const DownloadIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path d={'M12 15V3'} />
        <path d={'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'} />
        <path d={'m7 10 5 5 5-5'} />
    </svg>
);

export const PlusIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path d={'M5 12h14'} />
        <path d={'M12 5v14'} />
    </svg>
);

export const PenIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path
            d={
                'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z'
            }
        />
    </svg>
);

export const XIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path d={'M18 6 6 18'} />
        <path d={'m6 6 12 12'} />
    </svg>
);

export const ChevronLeftIcon = ({
    className,
    strokeWidth = 2,
    ...props
}: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path d={'m15 18-6-6 6-6'} />
    </svg>
);

export const ChevronRightIcon = ({
    className,
    strokeWidth = 2,
    ...props
}: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path d={'m9 18 6-6-6-6'} />
    </svg>
);

export const ZapIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path
            d={
                'M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z'
            }
        />
    </svg>
);

export const AwardIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path
            d={
                'm15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526'
            }
        />
        <circle
            cx={12}
            cy={8}
            r={6}
        />
    </svg>
);

export const TargetIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <circle
            cx={12}
            cy={12}
            r={10}
        />
        <circle
            cx={12}
            cy={12}
            r={6}
        />
        <circle
            cx={12}
            cy={12}
            r={2}
        />
    </svg>
);

export const SparklesIcon = ({ className, strokeWidth = 2, ...props }: PrepareMeetingIconProps) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        width={24}
        height={24}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
        aria-hidden={'true'}
        {...props}
    >
        <path
            d={
                'M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z'
            }
        />
        <path d={'M20 2v4'} />
        <path d={'M22 4h-4'} />
        <circle
            cx={4}
            cy={20}
            r={2}
        />
    </svg>
);
